"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchBusinessById = exports.useFetchAllBusiness = exports.useBusinessUpdate = exports.useBusinessCreate = exports.useBusinessFetch = void 0;
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const businessAction_1 = require("./businessAction");
function useBusinessFetch() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const businessLoading = (0, react_redux_1.useSelector)((state) => state['business/fetch'].loading);
    const businessData = (0, react_redux_1.useSelector)((state) => state['business/fetch'].data);
    const businessError = (0, react_redux_1.useSelector)((state) => state['business/fetch'].error);
    const fetchBusiness = (fetchPayLoad) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, businessAction_1.fetch)(fetchPayLoad));
    });
    return { fetchBusiness, businessLoading, businessData, businessError };
}
exports.useBusinessFetch = useBusinessFetch;
function useBusinessCreate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const businessCreateLoading = (0, react_redux_1.useSelector)((state) => state['business/create'].loading);
    const businessCreateData = (0, react_redux_1.useSelector)((state) => state['business/create'].data);
    const businessCreateError = (0, react_redux_1.useSelector)((state) => state['business/create'].error);
    const createBusiness = (createBusinessPayload, onComplete) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        try {
            const res = yield dispatch((0, businessAction_1.create)(createBusinessPayload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res.error;
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { createBusiness, businessCreateLoading, businessCreateData, businessCreateError };
}
exports.useBusinessCreate = useBusinessCreate;
function useBusinessUpdate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const businessUpdateLoading = (0, react_redux_1.useSelector)((state) => state['business/update'].loading);
    const businessUpdateData = (0, react_redux_1.useSelector)((state) => state['business/update'].data);
    const businessUpdateError = (0, react_redux_1.useSelector)((state) => state['business/update'].error);
    const updateBusiness = (updateBusinessPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, businessAction_1.update)(updateBusinessPayload));
    });
    return { updateBusiness, businessUpdateLoading, businessUpdateData, businessUpdateError };
}
exports.useBusinessUpdate = useBusinessUpdate;
function useFetchAllBusiness() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchAllBusinessLoading = (0, react_redux_1.useSelector)((state) => state['business/fetchAllBusiness'].loading);
    const fetchAllBusinessData = (0, react_redux_1.useSelector)((state) => state['business/fetchAllBusiness'].data);
    const fetchAllBusinessError = (0, react_redux_1.useSelector)((state) => state['business/fetchAllBusiness'].error);
    const fetchAllHostBusiness = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, businessAction_1.fetchAllBusiness)(fetchPayload));
    });
    return { fetchAllHostBusiness, fetchAllBusinessLoading, fetchAllBusinessData, fetchAllBusinessError };
}
exports.useFetchAllBusiness = useFetchAllBusiness;
function useFetchBusinessById() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchBusinessByApplicationLoading = (0, react_redux_1.useSelector)((state) => state['business/fetchBusinessById'].loading);
    const fetchBusinessByApplicationData = (0, react_redux_1.useSelector)((state) => state['business/fetchBusinessById'].data);
    const fetchBusinessByApplicationError = (0, react_redux_1.useSelector)((state) => state['business/fetchBusinessById'].error);
    const fetchBusinessByApplication = () => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, businessAction_1.fetchBusinessById)());
    });
    return { fetchBusinessByApplication, fetchBusinessByApplicationLoading, fetchBusinessByApplicationData, fetchBusinessByApplicationError };
}
exports.useFetchBusinessById = useFetchBusinessById;
